import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
import { jsx as _jsx } from "react/jsx-runtime";
import React, { useEffect, useState } from 'react';
import { TextField } from '../TextField';
const usCountryCode = '+1';
function removeCountryCode(value) {
    if (typeof value === 'string' && value.startsWith('+')) {
        return value.startsWith(usCountryCode) ? value.slice(usCountryCode.length) : '';
    }
    return value;
}
// WHY: see note on BaseTextField — forwardRef + MUI types collapses BiProps' discriminated union.
const USPhoneNumberInputImpl = /*#__PURE__*/ React.forwardRef(function USPhoneNumberInput(props, ref) {
    const { value, onChange = false } = props, rest = _object_without_properties(props, [
        "value",
        "onChange"
    ]);
    const [internalValue, setInternalValue] = useState(()=>removeCountryCode(value));
    useEffect(()=>{
        setInternalValue(removeCountryCode(value));
    }, [
        value
    ]);
    return /*#__PURE__*/ _jsx(TextField, _object_spread_props(_object_spread({}, rest), {
        ref: ref,
        prefix: usCountryCode,
        value: internalValue,
        type: "tel",
        onChange: (e)=>{
            const asPureDigits = e.target.value.replaceAll(/\D/g, '');
            setInternalValue(asPureDigits);
            onChange && onChange(_object_spread_props(_object_spread({}, e), {
                target: _object_spread_props(_object_spread({}, e.target), {
                    value: asPureDigits.length ? usCountryCode + asPureDigits : asPureDigits
                })
            }));
        }
    }));
});
export const USPhoneNumberInput = USPhoneNumberInputImpl;
